import React, { useCallback } from 'react';
import { H3 } from '@spark/ui-components/components/Typography';
import { Container, Row, Col } from 'react-bootstrap';
import { Card, CardBody, CardTitle } from '@spark/ui-components/components/Card';
import { useHistory, useParams } from 'react-router-dom';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { encerrarVaga } from '@spark/services/recrutamento-rh';
import { notification } from '@spark/ui-components/utils/notification';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import styled from 'styled-components';
import VagasProcessoEmAbertoCadastro from '../Cadastro/index';

const VagasProcessoEmAbertoDetalhes = () => {
  const history = useHistory();
  const { id } = useParams();

  const handleVoltar = useCallback(() => {
    history.goBack();
  }, [history]);

  const handleEditar = useCallback(() => {
    history.push(`/pages/vagas/processosemaberto/editar/${id}`);
  }, [history, id]);

  const handleEncerrarVaga = useCallback(async () => {
    try {
      if (!id) return;
      const confirmed = window.confirm('Tem certeza que deseja encerrar esta vaga?');
      if (!confirmed) return;
      const response = await encerrarVaga(Number(id));
      notification.success('Vaga encerrada com sucesso!');
      history.goBack();
    } catch (err) {
      notification.error('Não foi possível encerrar a vaga. Tente novamente.');
    }
  }, [id, history]);

  return <Container fluid>
    <Row>
      <Col md={12}>
        <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Processos em aberto'
        }, {
          name: 'Detalhes'
        }]} />

      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <Card>
          <CardBody>
            <HeaderWrap>
              <CardTitle>
                <H3>Detalhes da vaga</H3>
              </CardTitle>
              <ButtonContainer>
                <ButtonWithLoading variant="outline-secondary" onClick={handleVoltar}>
                  Voltar
                </ButtonWithLoading>
                <ButtonWithLoading variant="primary" onClick={handleEditar}>
                  Editar
                </ButtonWithLoading>
                <ButtonWithLoading
                  variant="primary"
                  onClick={handleEncerrarVaga}
                  style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}
                >
                  Encerrar vaga
                </ButtonWithLoading>
              </ButtonContainer>
            </HeaderWrap>
            <VagasProcessoEmAbertoCadastro isReadOnly={true} id={id} hideHeader={true} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </Container>;
};

export default VagasProcessoEmAbertoDetalhes;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;
const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
